<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        color="hrissecondary"
        class="white--text"
        :loading="progressing"
        v-on="on"
      >
        Remove Inactive Employee
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Remove Inactive Payroll Cycle Employees"
      text="Remove selected inactive employees from this payroll period"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-col cols="12">
            <v-card class="pa-4 elevation-5">
              <v-data-table
                v-model="selectedEmployees"
                v-validate="'required'"
                dense
                :loading="tableLoading"
                :headers="headers"
                :items="payrollCycleEmployees"
                item-key="company_employee_uid"
                hide-default-footer
                fixed-header
                disable-pagination
                item-value="company_employee_uid"
                show-select
                class="elevation-1 mb-3"
                height="272px"
                :error-messages="errors.collect('selectedEmployees')"
                data-vv-name="selectedEmployees"
                data-vv-as="employee selection"
              >        
                <template v-slot:top>
                  <v-row>
                    <v-toolbar
                      flat
                      color="white"
                    >
                      <v-toolbar-title>Employee Selection:</v-toolbar-title>
                    </v-toolbar>
                  </v-row>
                </template>

                <template v-slot:item.net_pay="{ item }">
                  {{ currencyFormatting(item.net_pay) }}
                </template>                        
              </v-data-table>
              
              <div :class="errors.first('selectedEmployees') ? 'py-0' : 'py-3'">
                <span class="red--text text--lighten-1 caption">{{ errors.first('selectedEmployees') }}</span>
              </div>
            </v-card>            
          </v-col>
            
          <v-col>
            <v-card-actions style="padding-top: 0px;padding-bottom: 0px;">
              <v-spacer />
              <v-btn
                :disabled="progressing"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                :loading="progressing"
                color="hrissecondary"
                class="white--text px-10"
                @click="submitForm"
              >
                Remove
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollCycleTransactionId: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        selectedEmployees: [],        
        payrollCycleEmployees: [],
        loadedPayrollCycleEmployees: [],
        tableLoading: false,
        payrollCycleEmpObj: null,
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'name',
            width: 400,
          },
          {
            text: 'Company',
            align: 'left',
            sortable: true,
            value: 'company_name',
            width: 400,
          },
          {
            text: 'Pay Status',
            align: 'left',
            sortable: true,
            value: 'pay_status',
          },
          {
            text: 'End Date',
            align: 'left',
            sortable: true,
            value: 'end_date',
          },
          {
            text: 'Nett Pay (RM)',
            align: 'right',
            sortable: false,
            value: 'net_pay',
            width: 150,
          },
        ],
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
        
        this.loadData()
      },   
    }, 

    methods: {
      loadData () {
        this.loadedPayrollCycleEmployees = []
        this.tableLoading = true

        this.$api.payrollCycleEmployees().listInactive(this.payrollCycleTransactionId)
          .then((res) => {
            res.data.map(emp => {
              this.payrollCycleEmpObj = {
                company_employee_uid: emp.company_employee_uid,
                name: emp.company_employee.employee.person.name,
                company_uid: emp.company_employee.company.id,
                company_name: emp.company_employee.company.name,
                pay_status: emp.company_employee.is_active_pay_status === 0 ? 'Inactive' : 'Active',
                end_date: emp.company_employee.end_date,
                net_pay: emp.payroll_cycle_employee_salary.current_cycle_net_salary,
              }
              this.loadedPayrollCycleEmployees.push(this.payrollCycleEmpObj)
            })

            this.payrollCycleEmployees = _.orderBy(this.loadedPayrollCycleEmployees, ['name'], ['asc'])
            this.tableLoading = false
          })
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollCycleEmployees().removeInactive(this.payrollCycleTransactionId, this.prepareFormData())
              .then(res => {
                this.$snack({ message: 'Payroll Cycle Employees removed successfully' })
                this.loadData()
                this.$emit('updated')
                this.selectedEmployees = []
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                } else this.$snack({ color: 'error', message: err.response.data.message })
              })
              .finally(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          selectedCompanyEmployees: this.selectedEmployees.map(emp => emp.company_employee_uid),
        }
      },  
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },     
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
.cursor-pointer >>> tr{
  cursor: pointer;
}
</style>
